import { useEffect, useState } from 'react';
import { NativeEventEmitter, NativeModules } from 'react-native';
import { isWeb } from '../utils';

type LifeCycle =
  | 'onLoginComplete'
  | 'viewWillAppear'
  | 'viewDidAppear'
  | 'viewWillDisappear'
  | 'viewDidDisappear';

const LIFE_CYCLE: Array<LifeCycle> = [
  'onLoginComplete',
  'viewWillAppear',
  'viewDidAppear',
  'viewWillDisappear',
  'viewDidDisappear',
];

/**
 * - 맨 처음 해당 훅이 실행되었을 때는 viewWillAppear과 viewDidAppear는 null일 수 있습니다.
 *   - useEffect에서 구독하는것보다 빠르게 앱의 라이프 사이클이 먼저 실행되기 때문에 보장되지 않습니다.
 * - 즉 페이지 첫 진입시 viewWillAppear과 viewDidAppear는 보장되지 않습니다.
 * - 웹의 경우 null을 반환합니다.
 */
export const useAppLifeCycle = () => {
  const [lifeCycle, setLifeCycle] = useState<LifeCycle | null>(null);

  useEffect(() => {
    if (isWeb) {
      return;
    }

    const eventEmitter = new NativeEventEmitter(
      NativeModules.ReactNativeBridge,
    );
    const subs = LIFE_CYCLE.map(lc =>
      eventEmitter.addListener(lc, () => {
        setLifeCycle(lc);
      }),
    );

    return () => {
      subs.forEach(s => s.remove());
    };
  }, [lifeCycle]);

  return { lifeCycle };
};
